export const GET_LIST_WAREHOUSE = {
    REQUEST: 'GET_LIST_WAREHOUSE_REQUEST',
    SUCCESS: 'GET_LIST_WAREHOUSE_SUCCESS',
    FAILED: 'GET_LIST_WAREHOUSE_FAILED',
};
